//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        display: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
        },
        message: {
            type: String,
        },
        type: {
            type: String,
        },
    },
    data() {
        return {
            alert: false,
        }
    },
    watch: {
        display: function() {
            this.alert = true
        },
    },
}
